import * as paymentsApi from "../../_api/paymentApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

export function savePaymentMethod(id, params) {
  return function (dispatch) {
    // dispatch(savePaymentMethodOptimistic(params));
    dispatch(beginApiCall());
    return paymentsApi.updatePaymentMethod(id, params);
  };
}

export function createPaymentMethod(params) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return paymentsApi
      .createPaymentMethod(params)
      .then((paymentMethod) => {
        return paymentMethod;
        // dispatch(createPaymentMethodSuccess(paymentMethod));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}


export function loadPaymentMethod(ClientId) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return paymentsApi
      .getPaymentMethod(ClientId)
      .then((paymentMethod) => {
        if (paymentMethod.length === 0) {
          return null;
        } else {
          //Remove any deleted cards if they got through
          const filteredPaymentMethod = paymentMethod.filter(
            (x) =>
              x.CreditCardStatus !== "Deleted" &&
              x.CreditCardStatus !== "Inactive"
          );
          if (filteredPaymentMethod.length === 0) {
           return null;
          } else {
           return filteredPaymentMethod;
          }
        }
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}


export function loadClientPaymentToken(ClientId) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return paymentsApi
      .getClientPaymentToken(ClientId)
      .then((ccToken) => {
        return ccToken;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}